import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConsumidorModel, ConsumidorService } from '../shared';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NbpInfoComponent } from '../../../shared';
import { CpfHelper } from '../../../shared/helpers/cpf-helper';
import { RegexHelper } from '../../../shared/helpers/regex-helper';

@Component({
  selector: 'app-consumidor-atualizar-cadastro',
  templateUrl: './consumidor-atualizar-cadastro.component.html',
  styleUrls: ['./consumidor-atualizar-cadastro.component.css']
})
export class ConsumidorAtualizarCadastroComponent implements OnInit, AfterViewInit {

    public contatoValido: boolean = false;
    
    public mensagemTelefoneOpcional: string = '';
    public mensagemTelefonePrincipal: string = '';    

    public mensagemEmailOpcional: string = '';    
    public mensagemEmailPrincipal: string ='';

    public msgAviso: string = '';
    public consumidor: ConsumidorModel = new ConsumidorModel();

    public messagePadraoContatoInvalido : string ='Existem dados de contato inválidos. Clique em "Alterar Dados" para atualizar.';
    public messagePadraoAlteracaoContato : string = 'Caso algum deles esteja desatualizado, clique em "Alterar Dados".';

    public messageTelefoneInvalido : string = 'Dados inválidos. Favor, digitar corretamente.';
    public messageTelefonesIguais : string = 'Telefone opcional NÃO pode ser igual ao de contato. Favor, alterar ou deixar apenas o telefone de contato';
    
    public messageEmailPrincipalInvalido : string = 'E-mail principal inválido.';
    public messageEmailOpcionalInvalido : string =  'E-mail opcional inválido.';
    public messageEmailsIguais: string = 'E-mail opcional NÃO pode ser igual ao principal. Favor, alterar ou deixar apenas o e-mail principal';

    public messageConfirmacaoAlteracaoEndereco: string = 'Verifique também se o seu endereço necessita de atualização.';

    constructor(private readonly consumidorService: ConsumidorService,
        private readonly router: Router, private readonly ngbModalService: NgbModal) { }
    

    ngAfterViewInit(): void {

        let emailsValidos = this.verificarContatoEmail(this.consumidor);
        let telefonesValidos = this.verificarContatoTelefonico(this.consumidor);

          if (!emailsValidos || !telefonesValidos) {
                this.contatoValido = false;
                this.msgAviso = this.messagePadraoContatoInvalido;
          }else{
            this.contatoValido = true;
          }
    }

    ngOnInit(): void {

        this.consumidor = this.consumidorService.getConsumidorModel();

        //Mensagem padrão caso não haja erros
        this.msgAviso = this.messagePadraoAlteracaoContato; 
    }

    confirmarCadastroAtualizado(){

        let cpfFormatado =  CpfHelper.AdicionarZerosEsquerda(this.consumidor.cpfBase, this.consumidor.cpfDigito);
        let cpfConsumidor : string = "'" + cpfFormatado + "'";

        // chamar serviço para atualizar a data de atualizacao do contato
        this.consumidorService.atualizarDataAtualizacaoContato(cpfConsumidor).subscribe(() => {
            const modalRef = this.ngbModalService.open(NbpInfoComponent, { size: 'lg'});
            modalRef.componentInstance.info = this.messageConfirmacaoAlteracaoEndereco;

            this.router.navigate(['consumidor/detalhar']);
        });
    }

    onAlterarDadosClick() {
        this.router.navigate(['/consumidor/dados_consumidor']);
    }

     verificarContatoTelefonico(consumidor: ConsumidorModel): boolean {
        
        const telefoneCompleto = `${consumidor.dddTelefone}${consumidor.telefone}`;
        const celularCompleto = `${consumidor.dddCelular}${consumidor.celular}`;

        let contatoEhValido : boolean = true;
        this.mensagemTelefoneOpcional = '';
        this.mensagemTelefonePrincipal = '';
  
        // Campos obrigatórios
        if (!consumidor.dddTelefone || !consumidor.telefone) {
            this.mensagemTelefonePrincipal = this.messageTelefoneInvalido;
            return false;
        }
        
        // Validação do celular
        // Se apenas um dos campos estiver preenchido, o telefone é inválido        
        if ((!consumidor.dddCelular && consumidor.celular) || (consumidor.dddCelular && !consumidor.celular)) {    
            this.mensagemTelefoneOpcional = this.messageTelefoneInvalido;
            contatoEhValido = false;

        } else {

            // se ambos os campos estiverem preenchidos, validar o telefone
            if (consumidor.dddCelular && consumidor.celular) {  
                          
                // se o ddd celular não for válido, exibir mensagem
                if (!RegexHelper.regexDDD.test(String(consumidor.dddCelular))){
                    this.mensagemTelefoneOpcional = this.messageTelefoneInvalido;
                    contatoEhValido = false;
                }

                // se o telefone não for válido, exibir mensagem
                if (!RegexHelper.regexTelefone.test(String(consumidor.celular))){
                    this.mensagemTelefoneOpcional = this.messageTelefoneInvalido;
                    contatoEhValido = false;
                }
            }             
        }  

        // Validação do telefone principal       
        if ((!consumidor.dddTelefone && consumidor.telefone) || (consumidor.dddTelefone && !consumidor.telefone)) {
            
            this.mensagemTelefonePrincipal = this.messageTelefoneInvalido;
            contatoEhValido = false;

        } else {

            // se ambos os campos estiverem preenchidos, validar o telefone
            if (consumidor.dddTelefone && consumidor.telefone) {     
                
                 // se o telefone não for válido, exibir mensagem
                if (!RegexHelper.regexDDD.test(String(consumidor.dddTelefone))){
                    this.mensagemTelefonePrincipal = this.messageTelefoneInvalido;
                    contatoEhValido = false;
                }

                // se o telefone não for válido, exibir mensagem
                if (!RegexHelper.regexTelefone.test(String(consumidor.telefone))){
                    this.mensagemTelefonePrincipal = this.messageTelefoneInvalido;
                    contatoEhValido = false;
                }
            }             
        }  

        // Telefones não podem ser iguais
        if (contatoEhValido && (telefoneCompleto === celularCompleto)) {
            this.mensagemTelefoneOpcional = this.messageTelefonesIguais;        
            return false;    
        }

        return contatoEhValido;
    }

    verificarContatoEmail(consumidor: ConsumidorModel): boolean {

        let contatoEhValido : boolean = true;
        this.mensagemEmailOpcional = '';
        this.mensagemEmailPrincipal = '';

        // Campos obrigatórios
        if (!consumidor.emailPrincipal) contatoEhValido = false;

        if((consumidor.emailPrincipal && !RegexHelper.regexMail.test(String(consumidor.emailPrincipal)))) {
            this.mensagemEmailPrincipal = this.messageEmailPrincipalInvalido;
            contatoEhValido = false;
        }

        if((consumidor.emailOpcional && !RegexHelper.regexMail.test(String(consumidor.emailOpcional)))) {
            this.mensagemEmailOpcional = this.messageEmailOpcionalInvalido;
            contatoEhValido = false;
        }

         // E-mails não podem ser iguais
        if (contatoEhValido && (consumidor.emailOpcional && consumidor.emailPrincipal.toLowerCase() === consumidor.emailOpcional.toLowerCase())) {
            this.mensagemEmailOpcional = this.messageEmailsIguais;    
            contatoEhValido = false;        
        }

        return contatoEhValido;
    }
}


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-atualizar-cadastro/consumidor-atualizar-cadastro.component.ts